import { Component } from '@angular/core';

@Component({
  selector: 'calsoft-cartordersuccess',
  templateUrl: './cartordersuccess.component.html',
  styleUrls: ['./cartordersuccess.component.scss']
})
export class CartordersuccessComponent {

  products = [
  {
    title: 'Lorem Ipsum dummy',
    salePrice: 140.99,
    originalPrice: 200.99,
    weight: '500 g',
    pieces: '9-12 Pieces',
    serving: 'Serves 4',
    image: 'assets/images/others/1.jpg'
  },
  {
    title: 'Lorem Ipsum dummy',
    salePrice: 140.99,
    originalPrice: 200.99,
    weight: '500 g',
    pieces: '9-12 Pieces',
    serving: 'Serves 4',
   image: 'assets/images/others/1.jpg'
  },
  {
    title: 'Lorem Ipsum dummy',
    salePrice: 140.99,
    originalPrice: 200.99,
    weight: '500 g',
    pieces: '9-12 Pieces',
    serving: 'Serves 4',
   image: 'assets/images/others/1.jpg'
  },
  {
    title: 'Lorem Ipsum dummy',
    salePrice: 140.99,
    originalPrice: 200.99,
    weight: '500 g',
    pieces: '9-12 Pieces',
    serving: 'Serves 4',
    image: 'assets/images/others/1.jpg'
  }
];



}
